import { render, staticRenderFns } from "./gallery-card1.vue?vue&type=template&id=8511aaf4&scoped=true"
import script from "./gallery-card1.vue?vue&type=script&lang=js"
export * from "./gallery-card1.vue?vue&type=script&lang=js"
import style0 from "./gallery-card1.vue?vue&type=style&index=0&id=8511aaf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8511aaf4",
  null
  
)

export default component.exports